import { injectable } from 'inversify';
import { titleCase } from 'title-case';
import { Component } from '../../../concepts/objects';
import { ExportAdapter } from '../dataExport/ExportAdapter';
import { ExportDimension, ExportDimensionType, ExportValue } from '../dataExport/ExportDimension';
import { Tag } from './Tag';

const getter = (c: Component, tagName: string) => {
    tagName = tagName.toLowerCase().trim();
    const hit = c.polarize(Tag).find(x => x.name.toLowerCase() === tagName);
    return hit?.value ?? hit?.name ?? null;
};

const TagExportDimensionType = (tagName: string) => {
    const type = ExportDimensionType({
        id: `tag:${tagName}`,
        label: titleCase(tagName),
        description: `Adds a column that contains the value of ${tagName} on each object.`,
        createInstance() {
            return ExportDimension({
                id: `tag:${tagName}`,
                label: titleCase(tagName),
                type,
                params: {},
                read(rows) {
                    const head = [ExportValue(this.id, this.label)];
                    const body = rows.map(c => ExportValue([c.id, this.id], getter(c, tagName)));
                    return [head.concat(body)];
                },
            });
        }
    });
    return type;
};

@injectable()
export class TagExports implements ExportAdapter {

    public readonly id = 'TagExports';
    public readonly label = 'Tags';
    public readonly priority = 30;

    public query(rows: Component[]): ExportDimensionType[] {
        return Array
            .from(new Set(rows.flatMap(x => x.polarize(Tag)).map(x => x.name)))
            .sort()
            .filter(x => !!x.trim())
            .map(x => TagExportDimensionType(x));
    }
}


